var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16544_42510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.741155 8.47073C-0.174703 7.51401 -0.250613 6.03044 0.562811 4.98524L3.31958 1.44293C3.82535 0.793044 4.60276 0.412964 5.42627 0.412964H19.6178C20.4478 0.412964 21.2305 0.798994 21.7357 1.45747L24.4484 4.99305C25.2488 6.03619 25.1704 7.50678 24.2637 8.45893L14.4559 18.7585C13.4057 19.8612 11.6473 19.8635 10.5943 18.7635L0.741155 8.47073Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16544_42510)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.853516 6.80501L4.12104 0.412964H20.9342L25.8386 6.80501L12.5276 20.7832L-0.853516 6.80501Z",
    fill: "url(#paint0_linear_16544_42510)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.853516 6.80505L5.30673 8.83927L12.5276 20.7833L-0.853516 6.80505Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8055 6.80505L19.5427 8.83927L12.5283 20.7833L25.8055 6.80505Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4252 1.81091L4.06641 0.410278L5.30688 8.83935H12.3901H12.4604H19.5422L20.7827 0.410278L12.4252 1.81091Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06641 0.410278L12.5278 3.21997L20.9344 0.413088L4.06641 0.410278Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.424 1.81055L5.30566 8.83899H19.541L12.424 1.81055Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5266 3.2196L5.30566 8.83899H19.541L12.5266 3.2196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30673 8.83935L-0.853516 6.80514L4.06625 0.410278H5.30673V8.83935Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.541 8.83935L25.8403 6.80514L20.9206 0.410278H19.6801L19.541 8.83935Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30566 8.83923L12.4914 20.765L19.541 8.83923H5.30566Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3,
    filter: "url(#filter0_i_16544_42510)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30566 8.83923L12.4914 20.765L19.541 8.83923H5.30566Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_16544_42510",
    x: 5.30566,
    y: 4.83923,
    width: 14.2354,
    height: 15.9258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16544_42510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16544_42510",
    x1: 12.4925,
    y1: 0.412964,
    x2: 12.4925,
    y2: 20.7832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#003B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamon);
export default __webpack_public_path__ + "static/media/Diamon.ba9453c6.svg";
export { ForwardRef as ReactComponent };